import { applyMiddleware, combineReducers, createStore } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
// middlewares
import gaEvents from './middlewares/gaEvents';
import actions from './modules/actions/reducer';
// modules
import modals from './modules/modals/reducer';
import tickets from './modules/tickets/reducer';
import users from './modules/users/reducer';
import views from './modules/views/reducer';
import snippets from './modules/snippets/reducer';
import preferences from './modules/preferences/reducer';
import copilot from './modules/copilot/reducer';
import chat from './modules/chat/reducer';

const middleware =
  process.env.REACT_APP_ENV === 'production'
    ? [promiseMiddleware(), thunk, gaEvents]
    : [promiseMiddleware(), thunk];

export const reducer = combineReducers({
  users,
  views,
  tickets,
  actions,
  modals,
  snippets,
  preferences,
  copilot,
  chat
});

const composeStoreWithMiddleware = applyMiddleware(...middleware)(createStore);

const configureStore = (initialState = {}) =>
  composeStoreWithMiddleware(
    reducer,
    initialState,
    // eslint-disable-next-line no-underscore-dangle
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  );

export default configureStore;

export const store = configureStore();
